module.exports = __webpack_public_path__ + "img/green-square-table-1.1ea493b2.png";